import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { IOriginState } from "../models/IOriginState";
 
const initialState = {elliPat: '', id: '', transaction:{}, isTPOConnectTraffic: false} satisfies IOriginState as IOriginState;

export const originSlice = createSlice({
    name: 'origin',
    initialState,
    reducers: {
        setOriginVals(state, action: PayloadAction<{pat: string, id: string, isTPOConnectTraffic?: boolean}>){
            state.elliPat = action.payload.pat;
            state.id = action.payload.id;
            if (action.payload.isTPOConnectTraffic !== undefined) {
                state.isTPOConnectTraffic = action.payload.isTPOConnectTraffic;
            }
        }
     } 
})
 
export const {setOriginVals } = originSlice.actions;
export default originSlice.reducer